import type WalkerService from '../../commons/services/walker.service';
import type {IWindowService} from 'angular';
import type {RichRecord} from 'typings/portaro.be.types';
import type {FileService} from '../../file/file.service';

export class KpCoverPresenter {
    public static presenterName = 'kpCoverPresenter';

    /*@ngInject*/
    constructor(private fileService: FileService, private walker: WalkerService, private $window: IWindowService, private CONTEXT_PATH: string) {
    }

    public openMediaViewer(record: RichRecord): Promise<string | Window> {
        // remove Promise.resolve after deprecating angularjs
        return Promise.resolve(
            this.walker.newPageOnContext('/media-viewer', {
                rootDirectory: record.directoryId,
                origin: this.$window.location.href
        }));
    }

    public getCoverPath(record: RichRecord | undefined): string {
        if (!!record) {
            return this.getRecordCoverPath(record);
        } else {
            return this.getPlaceholderCoverPath();
        }
    }

    public getRecordPath(record: RichRecord): string {
        return `${this.CONTEXT_PATH}/records/${record.id}`;
    }

    private getRecordCoverPath(record: RichRecord): string {
        if (record.cover && record.cover.id) {
            return `${this.fileService.getFilePath(record.cover)}/thumbnail`;
        } else {
            return `${this.getRecordPath(record)}/cover`;
        }
    }

    private getPlaceholderCoverPath(): string {
        return `${this.CONTEXT_PATH}/resources/img/covers/book.png`;
    }
}